/**
 * Form-Configuration for Vue-Form-Builder
 * @author Phat Tran
 */

const FORM_DEFAULT_DATA = {
    headline: "",
    subHeadline: "",
    isShowHeadline: false,

    logoUrl: "",
    logoStyleCss: "",
    logoLink:"",

    // <form></form> tag ??
    renderFormTag: false,
    formActionURL: "",
    formMethod: "POST",

    // Server-Side validation
    enableServerSideValidation: false,
    serverSideValidationEndpoint: "",

    // Submit button text
    submitButtonText: "Submit",

    // Multi-language translation
    supportedLanguages: ['en'],  // Array of enabled language codes (e.g., ['en', 'es', 'ru'])
    spanishEnabled: false,       // Legacy flag — kept for backward compat with existing forms
};

export {
    FORM_DEFAULT_DATA
}
